import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { CryptocurrencyConversionStep } from "@src/widgets/onboarding/classes/tours/ExchangeTour/steps/CryptocurrencyConversionStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class ExchangeTour extends BaseTour {
  name = ONBOARDING_TOURS.EXCHANGE

  steps = [new CryptocurrencyConversionStep()]
}
